import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

/**
 * @class AmenityCategory
 * @property {number} id
 * @property {string} title
 * @property {integer} status
 * @property {string} image
 */
export class AmenityCategory extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'title' ];
    }
    
    static get validationModel() {

        return {
            title: {
                label: 'CATEGORY_NAME_IN_ENGLISH',
                commonLabel: 'Category name'
            },
            title_ar: {
                label: 'CATEGORY_NAME_IN_ARABIC',
                commonLabel: 'Category name'
            },
        };
    }
}

AccessorsMutatorsDecorator('id', ...AmenityCategory.translatableAttributesWithLanguageAliases, 'status', 'image', 'image_file', 'default_property_amenities')(AmenityCategory);


// WEBPACK FOOTER //
// ./src/pms-api/models/amenity-category.model.js